export default __webpack_public_path__ + "static/media/contactsYellow.e2d56e81.svg";